// extracted by css-extract-rspack-plugin
export default {"description":"_fc863f29"};